var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 63,
    rx: 6,
    fill: "#EEEEEE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 57,
    height: 57,
    rx: 6,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.942C28.6625 30.942 26.75 30.1981 25.2625 28.7101C23.775 27.2222 23.0312 25.3092 23.0312 22.971C23.0312 20.6329 23.775 18.7198 25.2625 17.2319C26.75 15.744 28.6625 15 31 15C33.3375 15 35.25 15.744 36.7375 17.2319C38.225 18.7198 38.9688 20.6329 38.9688 22.971C38.9688 25.3092 38.225 27.2222 36.7375 28.7101C35.25 30.1981 33.3375 30.942 31 30.942ZM14 48V43.0048C14 41.7649 14.3099 40.6401 14.9297 39.6304C15.5495 38.6208 16.4437 37.868 17.6125 37.372C20.2688 36.2029 22.6328 35.3792 24.7047 34.901C26.7766 34.4227 28.875 34.1836 31 34.1836C33.125 34.1836 35.2146 34.4227 37.2687 34.901C39.3229 35.3792 41.6781 36.2029 44.3344 37.372C45.5031 37.9034 46.4062 38.6651 47.0438 39.657C47.6813 40.649 48 41.7649 48 43.0048V48H14Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/user-img.97e548b8e34c96531d20947bb3fdcf8a.svg";
export { ForwardRef as ReactComponent };